import { Injectable } from '@angular/core';
import {
  LoginAuthWithCredentials,
  LoginOAuth,
  SwapAuthForAccessTokens
} from '../../models';
import { UtilMethodsService } from './util-methods.service';
import { UtilServiceHelperSupportExtendedService } from './util-service-helper-support-extended.service';

@Injectable({
  providedIn: 'root'
})
export class UtilServiceHelperSupportService extends UtilServiceHelperSupportExtendedService {
  constructor(protected override utilMethodsService: UtilMethodsService) {
    super(utilMethodsService);
  }

  populatePingErrorResponse(
    authResponse:
      | LoginOAuth
      | LoginAuthWithCredentials
      | SwapAuthForAccessTokens,
    redirectfulFlowId?: string
  ) {
    let errorId = '';
    if (this.utilMethodsService.isPingErrorAuthResponse(authResponse)) {
      errorId = this.getPingErrorId(authResponse, redirectfulFlowId);
    }
    if (errorId.includes('ERROR_MSG')) {
      return errorId;
    }
    return `ERROR_MSG_${errorId}`;
  }

  getPingErrorId(
    authResponse:
      | LoginOAuth
      | LoginAuthWithCredentials
      | SwapAuthForAccessTokens,
    redirectfulFlowId = ''
  ): string {
    switch (true) {
      case this.utilMethodsService.isPingInvalidRequest(authResponse):
        return this.utilMethodsService.getPingInvalidRequestHelper(
          authResponse
        );
      case !!authResponse.error_description:
        return this.utilMethodsService.getErrorDescriptionHelper(authResponse);
      case this.utilMethodsService.isPingResourceNotFound(authResponse):
        return this.utilMethodsService.resourceNotFoundErrorId(
          authResponse,
          redirectfulFlowId
        );
      default:
        return this.getPingErrorIdHelper(authResponse);
    }
  }

  getPingErrorIdHelper(
    authResponse:
      | LoginOAuth
      | LoginAuthWithCredentials
      | SwapAuthForAccessTokens
  ): string {
    switch (true) {
      case authResponse.code === 'access_denied':
        return this.utilMethodsService.getAccessDeniedHelper(authResponse);
      case !!authResponse.error?.error:
        return this.utilMethodsService.getAuthResponseErrorObject(authResponse);
      case this.utilMethodsService.isPingValidationError(authResponse):
        return this.isPingValidationErrorHelper(authResponse);
      default:
        return this.getPingErrorIdHelperExtended(authResponse);
    }
  }

  getPingErrorIdHelperExtended(
    authResponse:
      | LoginOAuth
      | LoginAuthWithCredentials
      | SwapAuthForAccessTokens
  ): string {
    switch (true) {
      case !!(authResponse.errors && authResponse.errors[0].code):
        return this.utilMethodsService.getAuthResponseArrayCode(authResponse);
      default:
        return this.splitUserMessage(
          this.utilMethodsService.splitUserMessageHelper(authResponse)
        );
    }
  }

  isPingValidationErrorHelper(
    authResponse:
      | LoginOAuth
      | LoginAuthWithCredentials
      | SwapAuthForAccessTokens
  ): string {
    const errorDetails =
      this.utilMethodsService.getAuthResponseErrorDetails(authResponse);
    if (errorDetails.userMessage) {
      const message = this.splitUserMessage(errorDetails?.userMessage);
      return message;
    } else if (!errorDetails.userMessage && errorDetails.code) {
      return errorDetails.code;
    } else return '';
  }

  splitUserMessage(userMessage: string) {
    let message = '';
    if (userMessage) {
      const splitValue = userMessage.split('|');
      if (splitValue && splitValue.length > 1) {
        message = splitValue[0];
      } else {
        message = userMessage;
      }
    }
    return message;
  }

  pingErrorExists(
    authResponse:
      | LoginOAuth
      | LoginAuthWithCredentials
      | SwapAuthForAccessTokens
  ) {
    let pingErrorExists = false;
    if (authResponse) {
      if (this.isAuthErrorResponse(authResponse)) {
        pingErrorExists = true;
      }
    }
    return pingErrorExists;
  }

  isLocalStorageSupported() {
    const mod = 'data';
    let status = false;

    if (localStorage) {
      localStorage.setItem(mod, mod);
      localStorage.removeItem(mod);
    }
    {
      status = true;
    }
    return status;
  }
}
